var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95714 0 0 8.95714 0 20C0 31.0429 8.95714 40 20 40C31.0429 40 40 31.0429 40 20C40 8.95714 31.0429 0 20 0ZM20 37.1429C10.5429 37.1429 2.85714 29.4571 2.85714 20C2.85714 10.5429 10.5429 2.85714 20 2.85714C29.4571 2.85714 37.1429 10.5571 37.1429 20C37.1429 29.4429 29.4571 37.1429 20 37.1429ZM20.0429 15.1286C21.4857 15.1286 22.6571 13.9571 22.6571 12.5143C22.6571 11.0714 21.4857 9.9 20.0429 9.9C18.6 9.9 17.4286 11.0714 17.4286 12.5143C17.4286 13.9714 18.6 15.1286 20.0429 15.1286ZM21.6143 27.7857C19.9857 27.7857 20 26.6571 20.4286 25L21.7143 20L22.4571 17.1429H14.3V20H17.2714L15.8429 25.5429C15.3 27.4571 15.7143 30.2 19.6 30.2C22.1 30.2 23.4 28.8143 24.0857 27.4571C23.7286 27.1857 23.8143 27.2429 23.4571 26.9857C22.9857 27.4286 22.3714 27.7857 21.6143 27.7857Z",
    fill: "#133F7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLogo);
export default __webpack_public_path__ + "static/media/info-logo.c90a2c8b95981c44541857b568514f02.svg";
export { ForwardRef as ReactComponent };